import Button from "web/react/components/button/button";
import DiscoverModal from "web/react/components/discover-modal/discover-modal";
import { gettext } from "web/script/modules/django-i18n";
import LogotypeCheckbox, { Brand } from "web/react/components/logotype-checkbox/logotype-checkbox";
import React, { useState } from "react";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import styles from "./discover-header.css";

interface DiscoverHeaderProps {
    currentBrandName: string;
    relatedBrands: Brand[];
    onBrandClick: (string) => void;
}

function DiscoverHeader({
    currentBrandName,
    relatedBrands,
    onBrandClick,
}: DiscoverHeaderProps): JSX.Element {
    let [modalOpen, setModalOpen] = useState(false);
    const styleType = environment.getFeature("rebrand_2020") ? "tertiary" : "secondary";

    function handleModalClose(brands): void {
        brands.forEach((brand) => {
            onBrandClick(brand);
        });

        setModalOpen(false);
    }

    function discoverMoreOnClick(): void {
        setModalOpen(true);
        analytics.event("discover-more-button", "clicked", "feeds-discover");
    }

    return (
        <div>
            <div className={styles.brands}>
                {relatedBrands.map((brand) => {
                    let slug = brand.slug;
                    return (
                        <div key={`discover-header-${brand.image_url}`} className={styles.brand}>
                            <LogotypeCheckbox
                                onChange={(): void => onBrandClick(slug)}
                                {...brand}
                            />
                        </div>
                    );
                })}
                <div className={styles.fade} />
            </div>
            <div className={styles.button}>
                <Button
                    className={""}
                    styleType={styleType}
                    fullHeight={false}
                    fullWidth={true}
                    openInNewTab={false}
                    disabled={false}
                    onClick={discoverMoreOnClick}
                >
                    {// "Discover more"
                    gettext("feed.brand_personalise.discover_brand.discover_more_cta")}
                </Button>
            </div>
            <DiscoverModal
                currentBrandName={currentBrandName}
                relatedBrands={relatedBrands}
                open={modalOpen}
                onAdd={(): void => setModalOpen(false)}
                onClose={handleModalClose}
                onBrandClick={onBrandClick}
            />
        </div>
    );
}

export default DiscoverHeader;
